import Header from "./components/header";
import Display from "./components/display";
import Footer from "./components/footer";

function Error() {

    return (
        <div>
            <Header />
            <Display />
            <Footer />
        </div>
    )
}

export default Error;